/* eslint-disable */
import { productLensTypeErrorFragment } from "@saleor/fragments/errors";
import { productLensTypeFragment } from "@saleor/fragments/productLensType";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";
import {
  CreateProductLensType,
  CreateProductLensTypeVariables
} from "./types/CreateProductLensType";
import {
  ReOrderProductLensType,
  ReOrderProductLensTypeVariables
} from "./types/ReOrderProductLensType";
import {
  RemoveProductLensType,
  RemoveProductLensTypeVariables
} from "./types/RemoveProductLensType";
import {
  UpdateProductLensType,
  UpdateProductLensTypeVariables
} from "./types/UpdateProductLensType";

const createProductLensType = gql`
  ${productLensTypeFragment}
  ${productLensTypeErrorFragment}
  mutation CreateProductLensType($input: ProductLensTypeCreateInput!) {
    productLensTypeCreate(input: $input) {
      productLensType {
        ...ProductLensTypeFragment
      }
      errors: productLensTypeErrors {
        ...ProductLensTypeErrorFragment
      }
    }
  }
`;
export const useProductLensTypeCreateMutation = makeMutation<
  CreateProductLensType,
  CreateProductLensTypeVariables
>(createProductLensType);

const removeProductLensType = gql`
  ${productLensTypeErrorFragment}
  mutation RemoveProductLensType($id: ID!) {
    productLensTypeDelete(id: $id) {
      errors: productLensTypeErrors {
        ...ProductLensTypeErrorFragment
      }
    }
  }
`;
export const useProductLensTypeDeleteMutation = makeMutation<
  RemoveProductLensType,
  RemoveProductLensTypeVariables
>(removeProductLensType);

const updateProductLensType = gql`
  ${productLensTypeErrorFragment}
  mutation UpdateProductLensType(
    $id: ID!
    $input: ProductLensTypeCreateInput!
  ) {
    productLensTypeUpdate(id: $id, input: $input) {
      errors: productLensTypeErrors {
        ...ProductLensTypeErrorFragment
      }
    }
  }
`;
export const useUpdateProductLensTypeMutation = makeMutation<
  UpdateProductLensType,
  UpdateProductLensTypeVariables
>(updateProductLensType);

export const reOrderProductLensType = gql`
  mutation ReOrderProductLensType($move: ReorderInput!) {
    productLensTypeReorder(moves: [$move]) {
      productLensTypeList {
        id
        name
        extraChargeCode
        skuStartCode
        sortOrder
        isActive
        sortOrder
      }
      errors: productLensTypeErrors {
        message
      }
    }
  }
`;

export const useReOrderProductLensTypeMutation = makeMutation<
  ReOrderProductLensType,
  ReOrderProductLensTypeVariables
>(reOrderProductLensType);
